









































import { Component, Vue } from "vue-property-decorator";

@Component
export default class Dishes extends Vue {
  data() {
    return {
      dishes: [
        {
          name: "Indian Burger",
          img: require("../assets/food_item/food_item_1.png"),
          caption:
            "Was brean shed moveth day yielding tree yielding day were female and"
        },
        {
          name: "Cremy Noodles",
          img: require("../assets/food_item/food_item_2.png"),
          caption:
            "Was brean shed moveth day yielding tree yielding day were female and"
        },
        {
          name: "Honey Meat",
          img: require("../assets/food_item/food_item_3.png"),
          caption:
            "Was brean shed moveth day yielding tree yielding day were female and"
        }
      ]
    };
  }
}
